import {tns} from 'tiny-slider/src/tiny-slider';

export default class TimelineSlider {
  constructor(element) {
    const container = element.querySelector('.js-slider-items');

    /** find the 'active' item */
    if (container) {
      const activeElement = container.querySelector('.timeline-project__item--active');
      let startIndex = 0;

      if (activeElement) {
        startIndex = activeElement.dataset.loopIndex;
      }

      this.slider = tns({
        container,
        autoWidth: true,
        loop: false,
        gutter: 0,
        nav: false,
        center: true,
        speed: 200,
        startIndex: startIndex,
        controlsContainer: element.querySelector('.js-slider-arrows'),
        onInit: (info) => {
          info.slideItems[info.index].classList.add('is--current');
        }
      });

      const slideChangeEvent = new Event('slideChanged');

      this.slider.events.on('transitionEnd', (info) => {
        const activeIndex = info.index;
        const activeItem = info.slideItems[activeIndex];

        if (activeItem) {
          const card = activeItem.querySelector('.timeline-project__item');

          /** disable for all other cards */
          [...info.slideItems].forEach(item => {
            if (item) {
              const itemCard = item.querySelector('.timeline-project__item')

              item.classList.remove('timeline-project__item--selected')
              if (itemCard) {
                itemCard.classList.remove('timeline-project__item--selected')
              }
            }
          })

          /** add for active card */
          activeItem.classList.add('timeline-project__item--selected');
          if (card) card.classList.add('timeline-project__item--selected');

          container.dispatchEvent(slideChangeEvent)
        }
      });
    }
  }
}
